import o from "./index.es106.js";
var t = o.t("component_component_calendarPickerLabel_datesFilterDateRange"),
    e = t.replace(/[a-zA-Z]/g, "0"),
    c = /^\d{4}-\d{2}-\d{2}$/,
    _ = e,
    E = "".concat(e, " \u2014 ").concat(e),
    A = t,
    a = "".concat(t, " \u2014 ").concat(t),
    s = "Select date",
    L = o.t("component_component_calendarPickerPromptLabel_datesFilterPrompt"),
    S = [4, 7, 17, 20],
    r = [10];
export { E as DATE_MASK_RANGE_VALUE, c as DATE_MASK_SINGLE_REG, _ as DATE_MASK_VALUE, r as LONG_SEPARATOR_POSITIONS, A as PLACEHOLDER_MASK, L as PLACEHOLDER_RANGE, a as PLACEHOLDER_RANGE_FOCUSED, s as PLACEHOLDER_SINGLE, S as SHORT_SEPARATOR_POSITIONS, t as dateFormat };